export type NumberRangeField = {from: number | null; to: number | null};
